import React from 'react';

interface CharacterLoadingProps {
  characterGenerationProgress?: number;
}

const CharacterLoading: React.FC<CharacterLoadingProps> = ({ characterGenerationProgress = 10 }) => {
  return (
    <div>
      <div className="flex flex-col items-center justify-center pt-5 pb-6">
        <img className="w-24 h-24 mb-3" src="/loading.gif" alt="Loading" />
        <div className="mb-2 text-sm text-storyblue dark:text-gray-400">
          <span className="font-semibold text-storygreen">
            {`Generating Character ${characterGenerationProgress}%`}
          </span>
          {/* Progress bar */}
          <div className="w-64 mx-auto mt-3 mb-4 bg-gray-200 rounded-full h-3 dark:bg-gray-700 overflow-hidden">
            <div
              className="bg-storygreen h-3 rounded-full transition-all duration-700 ease-in-out"
              style={{ width: `${Math.min(characterGenerationProgress, 100)}%` }}
            />
          </div>
          <p>Character Builder will take a few minutes</p>
          <p className="text-storygreen mt-8">
            All characters created will be saved in your character library.<br />
            As your character is being created, you'll have the choice of four distinct options.
          </p>
          <p className="text-storygreen">
            If you wish to expand the range of choices, you can adjust any of the input parameters and then select
            "Regenerate Character",<br />
            or you can keep the options unchanged and select "Regenerate Character".
          </p>
        </div>
      </div>
    </div>
  );
};

export default CharacterLoading;
